import React from 'react';
import { Hero } from '../components/Hero';
import { SalesCopy } from '../components/SalesCopy';
import { Features } from '../components/Features';
import { Promise } from '../components/Promise';
import { Offer } from '../components/Offer';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  useMetaPixel();
  return <main className="min-h-screen bg-cream selection:bg-gold-200 selection:text-olive-900" data-id="element-187">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-188">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=826332227035064&ev=PageView&noscript=1" alt="" data-id="element-189" />
      </noscript>

      <Hero data-id="element-190" />
      <SalesCopy data-id="element-191" />
      <Features data-id="element-192" />
      <Promise data-id="element-193" />
      <Offer data-id="element-194" />
      <Footer data-id="element-195" />
      <SalesNotification data-id="element-196" />
    </main>;
}